import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Loader2, Star } from "lucide-react";
import { API } from "@/lib/api";
import { LOGO_URL } from "@/lib/brand";
import { TalentCardView } from "@/components/TalentCardView";

export default function TalentCard() {
  const { token } = useParams();
  const [card, setCard] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    axios.get(`${API}/talent/${token}`)
      .then(({ data }) => setCard(data))
      .catch((e) => setError(e.response?.status === 410 ? "This talent card link has expired." : "This talent card could not be found."));
  }, [token]);

  if (error) return (
    <div className="min-h-screen bg-[#050505] text-white flex flex-col items-center justify-center px-6 text-center" data-testid="talent-error">
      <img src={LOGO_URL} alt="Splash Creative Hub" className="w-[150px] h-auto object-contain mb-8" />
      <p className="text-sm text-[#A1A1AA]">{error}</p>
    </div>
  );

  if (!card) return <div className="min-h-screen bg-[#050505] flex items-center justify-center"><Loader2 className="w-8 h-8 animate-spin text-[#FF4D00]" /></div>;

  return (
    <div className="min-h-screen bg-[#050505] text-white pro-stage-bg">
      <header className="border-b border-white/10">
        <div className="max-w-[900px] mx-auto px-6 lg:px-10 py-5 flex items-center justify-between">
          <img src={LOGO_URL} alt="Splash Creative Hub" className="w-[140px] h-auto object-contain" />
          <span className="text-[10px] uppercase tracking-[0.3em] text-[#A1A1AA] flex items-center gap-2"><Star className="w-3.5 h-3.5 text-[#FF4D00]" /> Vetted Talent</span>
        </div>
      </header>

      <main className="max-w-[900px] mx-auto px-6 lg:px-10 py-20">
        <TalentCardView card={card} />
      </main>

      <footer className="border-t border-white/10 mt-8">
        <div className="max-w-[900px] mx-auto px-6 lg:px-10 py-8 text-xs text-[#A1A1AA] flex items-center justify-between">
          <span className="font-bebas text-lg text-white tracking-wide">SPLASH CREATIVE HUB</span>
          <span>Presented by the Splash Team</span>
        </div>
      </footer>
    </div>
  );
}
